import React, { useEffect } from 'react';
import { TableCustom, FilterCustom, TabCustom } from '../common';
import { Box } from '@material-ui/core';
import {
  ResponseData,
  PositionHead,
  MainFilter,
  InterviewStatus,
  Tabs,
} from '../../data/ApplicantsData';
import '../positions/Positions.scss';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { commonFn } from '../../util/commonFn';

// Start: Main Function
export const Applicants = ({ match }) => {
  const history = useHistory();
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    document.title = 'ATS - Applicants';
  });

  // Actions click function
  const clickOnCell = (data, event) => {
    event.stopPropagation();
    const applicantId = data.row[0].value;

    applicantId && data?.action?.type === 'edit' && history.push(`/applicants/edit/${applicantId}`);
    applicantId && data.action?.type === 'view' && history.push(`/applicants/view/${applicantId}`);
    applicantId &&
      data.action.type === 'delete' &&
      MySwal.fire({
        title: 'Are you sure?',
        text: 'You want to delete the applicant',
        icon: 'warning',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        result = result.isConfirmed
          ? Swal.fire({
              title: 'Success!',
              text: 'Applicant has been deleted',
              icon: 'success',
              iconColor: '#3085d6',
            })
          : '';
      });
  };

  const tableData = { data: ResponseData, head: PositionHead, clickOnCell: clickOnCell };
  const filterData = { filter: MainFilter, data: InterviewStatus };

  const tabs = {
    ...Tabs,
    list: commonFn.updateLink(Tabs.list, match),
  };

  console.log("tabs", tabs);

  return (
    <div>
      {/* Filter Card Component */}
      <TabCustom {...tabs} />
      <Box mt={2} mb={4}>
        <FilterCustom {...filterData} />
      </Box>

      {/* Table component */}
      <Box mb={4}>
        <TableCustom {...tableData} />
      </Box>
    </div>
  );
};
